function pageWindow(current, total_pages) {
  var max_buttons = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
  if (total_pages <= max_buttons) {
    return Array.from({
      length: total_pages
    }, function (_, i) {
      return i + 1;
    });
  }
  var half = Math.floor(max_buttons / 2);
  var start = Math.max(1, current - half);
  var end = start + max_buttons - 1;
  if (end > total_pages) {
    end = total_pages;
    start = Math.max(1, end - max_buttons + 1);
  }
  return Array.from({
    length: end - start + 1
  }, function (_, i) {
    return start + i;
  });
}
module.exports = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$pagination = _ref.pagination,
    pagination = _ref$pagination === void 0 ? null : _ref$pagination,
    _ref$empty = _ref.empty,
    empty = _ref$empty === void 0 ? false : _ref$empty,
    _ref$categoryLabel = _ref.categoryLabel,
    categoryLabel = _ref$categoryLabel === void 0 ? '' : _ref$categoryLabel;
  if (empty) {
    var label = categoryLabel ? " in ".concat(categoryLabel) : '';
    return "\n      <div class=\"catalog-empty empty\">\n        <h2>No listings".concat(label, "</h2>\n        <p>Nothing is for sale in this category yet.</p>\n      </div>\n    ");
  }
  if (!pagination || !pagination.total) {
    return '';
  }
  var page = pagination.page,
    total = pagination.total,
    total_pages = pagination.total_pages,
    has_next = pagination.has_next,
    has_previous = pagination.has_previous;
  if (total_pages <= 1) {
    return "\n      <p class=\"catalog-info\" role=\"status\">Showing all listings.</p>\n    ";
  }
  var pages = pageWindow(page, total_pages).map(function (n) {
    var active = n === page ? ' is-active' : '';
    var aria = n === page ? ' aria-current="page"' : '';
    return "<button type=\"button\" class=\"page-btn".concat(active, "\" data-page=\"").concat(n, "\"").concat(aria, ">").concat(n, "</button>");
  }).join('');
  var prev_disabled = has_previous ? '' : ' disabled';
  var next_disabled = has_next ? '' : ' disabled';
  return "\n    <nav class=\"catalog-pagination\" aria-label=\"Listings pages\">\n      <button type=\"button\" class=\"nav-btn\" data-page-action=\"prev\"".concat(prev_disabled, ">Previous</button>\n      <div class=\"pages\">").concat(pages, "</div>\n      <button type=\"button\" class=\"nav-btn\" data-page-action=\"next\"").concat(next_disabled, ">Next</button>\n    </nav>\n    <p class=\"catalog-info\" role=\"status\">Page ").concat(page, " of ").concat(total_pages, " \xB7 ").concat(total, " listings</p>\n  ");
};
function attachCatalogFooterEvents(footer) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    page = _ref2.page,
    pagination = _ref2.pagination,
    onPage = _ref2.onPage;
  if (!footer || typeof onPage !== 'function') {
    return;
  }
  footer.querySelectorAll('[data-page]').forEach(function (btn) {
    btn.onclick = function (e) {
      e.preventDefault();
      var next = Number(btn.getAttribute('data-page'));
      if (next && next !== page) {
        onPage(next);
      }
    };
  });
  var prev = footer.querySelector('[data-page-action="prev"]');
  if (prev) {
    prev.onclick = function (e) {
      e.preventDefault();
      if (pagination !== null && pagination !== void 0 && pagination.has_previous) {
        onPage(page - 1);
      }
    };
  }
  var next = footer.querySelector('[data-page-action="next"]');
  if (next) {
    next.onclick = function (e) {
      e.preventDefault();
      if (pagination !== null && pagination !== void 0 && pagination.has_next) {
        onPage(page + 1);
      }
    };
  }
}
module.exports.attachCatalogFooterEvents = attachCatalogFooterEvents;